import { Navigate, Outlet } from "react-router-dom";
import { useEffect } from "react";

import { INVITE_AUTH_CALLBACK_PATH } from "@/lib/auth-routes";
import { useAuth } from "@/lib/auth";
import { mustSetPassword } from "@/types/auth";

function AuthLoading() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-whart-bg text-sm text-neutral-500">
      Chargement…
    </div>
  );
}

export function OnboardingRoute() {
  const { user, isLoading } = useAuth();

  useEffect(() => {
    const hash = window.location.hash;

    if (!hash.includes("access_token") || !hash.includes("refresh_token")) {
      return;
    }

    window.location.replace(`${INVITE_AUTH_CALLBACK_PATH}${hash}`);
  }, []);

  if (isLoading) {
    return <AuthLoading />;
  }

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (!mustSetPassword()) {
    return <Navigate to="/dashboard" replace />;
  }

  return <Outlet />;
}
